/* ============================================================
   STROVIA — shared behaviour
   Ported from html-design/index.html (inline <script>, lines 881–921).
   Vanilla ES5-ish to match the source. Loaded with defer.

   Public API used by sections:
     Strovia.toast(msg)        -> bottom toast
     Strovia.addToCart(id,qty) -> real Shopify AJAX add, then toast
     Strovia.observe(root)     -> wire .reveal + [data-count] inside root
   ============================================================ */
window.Strovia = (function () {
  'use strict';

  /* ---------- Toast ---------- */
  function toast(msg) {
    var t = document.getElementById('StroviaToast');
    if (!t) return;
    var m = document.getElementById('StroviaToastMsg');
    if (m) m.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._h);
    t._h = setTimeout(function () {
      t.classList.remove('show');
    }, 2600);
  }

  /* ---------- Cart ----------
     Real Shopify add-to-cart. Refreshes Dawn's cart bubble so the
     stock header/cart-drawer stays in sync with our custom sections. */
  function refreshCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nodes = document.querySelectorAll('[data-strovia-cart-count]');
        for (var i = 0; i < nodes.length; i++) {
          nodes[i].textContent = cart.item_count;
          nodes[i].classList.toggle('is-empty', cart.item_count === 0);
        }
        document.dispatchEvent(
          new CustomEvent('strovia:cart:updated', { detail: { cart: cart } })
        );
        return cart;
      });
  }

  function addToCart(variantId, qty, title) {
    if (!variantId) {
      toast('This product is unavailable');
      return Promise.resolve();
    }
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          toast(res.description || 'Could not add to cart');
          return;
        }
        return refreshCartCount().then(function () {
          toast((title || res.product_title || 'Item') + ' added to cart');
        });
      })
      .catch(function () {
        toast('Could not add to cart — please try again');
      });
  }

  /* ---------- Count-up metrics ---------- */
  function countUp(el) {
    if (el._counted) return;
    var target = parseInt(el.dataset.count, 10);
    /* Guard: countUp OVERWRITES textContent. `data-count` therefore means
       "this element is a number that animates" and nothing else. Refuse to
       run on anything with child elements, or on a non-numeric value — a
       stray data-count on a container would otherwise wipe its children.
       (This happened once: the PDP variant selector carried data-count and
       had its four option buttons replaced by the digit "4".) */
    if (isNaN(target) || el.children.length) return;
    el._counted = true;
    var start = null;
    var dur = 1600;

    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString();
      if (p < 1) requestAnimationFrame(step);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = target.toLocaleString();
      return;
    }
    requestAnimationFrame(step);
  }

  /* ---------- Reveals ----------
     When a block reveals, also start the count-up for any [data-count]
     inside it, so numbers animate as the block fades in (not earlier,
     while hidden). A second observer is the safety net for [data-count]
     that isn't wrapped in a .reveal. */
  var io = new IntersectionObserver(
    function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target;
        t.classList.add('in');
        var ns = t.querySelectorAll('[data-count]');
        for (var i = 0; i < ns.length; i++) countUp(ns[i]);
        io.unobserve(t);
      });
    },
    { threshold: 0.12 }
  );

  var cio = new IntersectionObserver(
    function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        countUp(e.target);
        cio.unobserve(e.target);
      });
    },
    { threshold: 0.6 }
  );

  function observe(root) {
    var scope = root || document;
    scope.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      io.observe(el);
    });
    scope.querySelectorAll('[data-count]').forEach(function (el) {
      if (!el.closest('.reveal')) cio.observe(el);
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    observe(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  /* Theme editor: re-wire whenever a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    observe(e.target);
  });

  return {
    toast: toast,
    addToCart: addToCart,
    refreshCartCount: refreshCartCount,
    countUp: countUp,
    observe: observe
  };
})();
